import Vue from 'vue';

export const CopyToClipboard = {
  methods: {
    copyToClipboard: async (snippet: string, description?: string) => {
      // @ts-ignore
      await Vue.prototype.$copyText(snippet);
      // @ts-ignore
      const message = description ? `${description} copied to clipboard` : `Copied to clipboard: ${snippet}`;
      Vue.prototype.$message({
        message,
        type: 'info',
      });
    },
  },
};
